import { render, staticRenderFns } from "./data63.vue?vue&type=template&id=377d3b93&scoped=true&"
import script from "./data63.vue?vue&type=script&lang=js&"
export * from "./data63.vue?vue&type=script&lang=js&"
import style1 from "./data63.vue?vue&type=style&index=1&id=377d3b93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d3b93",
  null
  
)

export default component.exports